import { render, staticRenderFns } from "./LabeledText.vue?vue&type=template&id=5f6a9328&scoped=true&"
import script from "./LabeledText.vue?vue&type=script&lang=js&"
export * from "./LabeledText.vue?vue&type=script&lang=js&"
import style0 from "./LabeledText.vue?vue&type=style&index=0&id=5f6a9328&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f6a9328",
  null
  
)

export default component.exports